var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creator-point"},[_c('div',{staticClass:"creator-point__img"},[_c('div',{staticClass:"creator-point__empty-star"},[_vm._v("★★★★★")]),_c('div',{staticClass:"creator-point__filled-star",style:(_vm.reviewPointStarStyle)},[_vm._v("★★★★★")])]),_c('div',{staticClass:"creator-point__text"},[_vm._v(_vm._s(_vm.reviewPointAverage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }